import { createFileRoute } from "@tanstack/react-router";
import ScoutCardDetail from "@/pages/ScoutCardDetail";

export const Route = createFileRoute("/admin/card/$id/")({
  component: ScoutCardDetail,
});
